module.exports = __webpack_public_path__ + "img/benefits-box.52658270.svg";